import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Badge } from "antd";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";

import "./style-slider.css";

import menuData from "../../containers/home/menu.json";
import HeaderFarms from "../../utils/header_farms.js";
import { requestToken } from "../../auth/AuthServices.js";
import API from "../../services";

function codeCompany() {
  const sessionData = localStorage.getItem("session_signin");
  try {
    return sessionData ? JSON.parse(sessionData).company.code : "-";
  } catch {
    return "-";
  }
}

const companyCode = codeCompany();

const Slider = () => {

  const [selectedApp, setSelectedApp] = useState();
  const navigate = useNavigate();
  const reportMenu = menuData.report;

  const onMenuClick = async (item) => {
    if (!item) {
      console.warn("⚠️ onMenuClick dipanggil tanpa item yang valid.");
      return;
    }

    setSelectedApp(item);
    const accessToken = await requestToken();
    if (accessToken) {
      handleMenuClick(item, accessToken);
    }
  };

  function handleMenuClick(items, token) {
    if (!items) {
      console.warn("handleMenuClick: items is undefined, skipping API call.");
      return;
    }

    if (!token) {
      console.error("Token is undefined!");
      return;
    }

    try {
      const sessionData = localStorage.getItem("session_signin");
      const fullname = sessionData ? JSON.parse(sessionData).fullname : "-";
      const employee_id = sessionData ? JSON.parse(sessionData).nik : "-";

      API.menuLog(HeaderFarms(token), {
        employee_id: employee_id,
        app_name: items.app_name || "Unknown",
        sort: items.sort,
        code: items.code,
        fullname: fullname,
      });
    } catch (err) {
      console.error("handleMenuClick: failed send data", err);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedApp) {
        // console.warn("⚠️ selectedApp is undefined, skipping API call.");
        return;
      }

      try {
        const accessToken = await requestToken();
        handleMenuClick(selectedApp, accessToken);
        if (!accessToken || !selectedApp) {
          
          
        }
      } catch (error) {
        console.error("❌ Gagal mengambil data:", error);
      }
    };
    fetchData();
  }, [selectedApp]);
  return (
    <>
      <main className="swiper-main">
        <div className="swiper-container mt-3">
          <div className="report-header" />
          <Swiper
            className="mt-2"
            modules={[Pagination]}
            grabCursor={true}
            initialSlide={1}
            centeredSlides={true}
            slidesPerView="auto"
            speed={800}
            slideToClickedSlide={true}
            pagination={{ el: ".swiper-pagination", clickable: true }}
            breakpoints={{
              320: { spaceBetween: 40 },
              430: { spaceBetween: 50 },
              580: { spaceBetween: 70 },
              650: { spaceBetween: 80 },
            }}
          >
            {["BRM", "CPM"].includes('BRM') && reportMenu.length > 0 && (
              <SwiperSlide
                className="swiper-slide slide-1"
                style={{ position: "relative" }}
              >
                <div className="swiper-title" />
                <div className="swiper-content">
                  <div
                    onClick={() => {
                      onMenuClick(reportMenu[0]); // Tetap panggil onMenuClick
                      navigate(reportMenu[0].navigate);
                    }}
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      backgroundColor: "#eb8e03",
                      color: "white",
                      fontSize: "10px",
                      padding: "6px 16px",
                      borderTopLeftRadius: "12px",
                      borderBottomRightRadius: "6px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                      zIndex: "10",
                      backgroundImage:
                        "url('https://assets.tokopedia.net/assets-tokopedia-lite/v2/zeus/kratos/b33421a4.svg')",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.8")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    See Detail
                  </div>
                </div>
              </SwiperSlide>
            )}

            {["BRM", "CPM"].includes('BRM') && reportMenu.length > 0 && (
              <SwiperSlide
                className="swiper-slide slide-3"
                style={{ position: "relative" }}
              >
                {/* <Badge.Ribbon
                  className="badge-new"
                  text="New"
                  color="red"
                  placement="start"
                  style={{ marginTop: 120, width: 70, textAlign: "center" }}
                ></Badge.Ribbon> */}
                <div className="swiper-title" />
                <div className="swiper-content">
                  <div
                    onClick={() => {
                      onMenuClick(reportMenu[2]); // Tetap panggil onMenuClick
                      navigate(reportMenu[2].navigate);
                    }}
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      backgroundColor: "#eb8e03",
                      color: "white",
                      fontSize: "10px",
                      padding: "6px 16px",
                      borderTopLeftRadius: "12px",
                      borderBottomRightRadius: "6px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                      zIndex: "10",
                      backgroundImage:
                        "url('https://assets.tokopedia.net/assets-tokopedia-lite/v2/zeus/kratos/b33421a4.svg')",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.8")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    See Detail
                  </div>
                </div>
              </SwiperSlide>
            )}

            {reportMenu.length > 1 && (
              <SwiperSlide
                className="swiper-slide slide-2"
                style={{ position: "relative" }}
              >
                <div className="swiper-title" />
                <div className="swiper-content">
                  <div
                    onClick={() => {
                      onMenuClick(reportMenu[1]); // Tetap panggil onMenuClick
                      navigate(reportMenu[1].navigate);
                    }}
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "0",
                      backgroundColor: "#eb8e03",
                      color: "white",
                      fontSize: "10px",
                      padding: "6px 16px",
                      borderTopLeftRadius: "12px",
                      borderBottomRightRadius: "6px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                      zIndex: "10",
                      backgroundImage:
                        "url('https://assets.tokopedia.net/assets-tokopedia-lite/v2/zeus/kratos/b33421a4.svg')",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.opacity = "0.8")
                    }
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    See Detail
                  </div>
                </div>
              </SwiperSlide>
            )}

            <div className="swiper-pagination" />
          </Swiper>
        </div>
      </main>
    </>
  );
};

export default Slider;
